<template>
  <div class="SubmitPapers">
      <el-dialog width="425px" :visible.sync="popuStatus" :before-close="closePopu">
          <img src="~common/images/examination/icon-bi.png" alt="bi">
          <p>你确认提交试卷？</p>
          <div class="btnlist">
              <el-button type="info" @click="closePopu">继续做题</el-button>
              <el-button type="primary" @click="viewingResults">提交试卷</el-button>
          </div>
      </el-dialog>
  </div>
  <!-- end 提交试卷弹窗 -->
</template>

<script>
import {mapActions} from 'vuex'
import {updateUserexamInfo} from 'api/questionbank'
export default {
  name: 'SubmitPapers',
  data () {
    return {
        popuStatus: false
    }
  },
  mounted () {},
  methods: {
      startPopu() { // 开启弹窗
          this.popuStatus = true
      },
      closePopu() { // 关闭弹窗
        this.popuStatus = false
      },
      viewingResults() {    // 提交试卷

        // 获取已做题目答案
        let answerList = this.$parent._combinationExaminationAontent()
        // 回调考试提交接口
        this.$parent.CallbackSaveExamRecord(answerList, () => {
            this.setLoading(true)
            updateUserexamInfo({
                data: {exampid: this.$route.query.examid},
                success: data => {
                    this.setLoading(false)
                    if (data.code == '000')
                        this.$router.push({name: 'ViewingResults', query: this.$route.query})
                    else 
                        this.$message.error(data.msg)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        })
      },
      ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.SubmitPapers {
    .el-dialog__body {
        padding-top: 18px;
    }
    img {
        margin: auto;
        width: 49px;
        height: 55px;
    }
    p {
        margin-top: 22px;
        font-size: 16px;
        text-align: center;
    }
    .btnlist {
        margin-top: 25px;
        text-align: center;

        .el-button {
            min-height: 30px;
            height: 30px;
            padding: 5px 32px;
            span {
                font-size: 14px;
            }
            & ~ .el-button {
                margin-left: 30px;
            }
        }
    }

}
</style>